import { put, takeLatest } from 'redux-saga/effects';
import {
  CREATE_CUSTOMER,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  REQUEST_ERROR,
  SET_LOADING,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_AVATAR,
  UPDATE_CUSTOMER_AVATAR_SUCCESS,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_USERNAME,
  UPDATE_CUSTOMER_USERNAME_SUCCESS,
} from '../types/customer';

import {
  requestCreateCustomerApi,
  requestCreateCustomerProfilePictureApi,
  requestCustomerDetailApi,
  requestCustomersApi,
  requestDeleteCustomerProfilePictureApi,
  requestUpdateCustomerApi,
  requestUserDetailApi,
} from '../requests/customer';

import { onFailRequest } from '@/utils';
import Message from '@/components/common/message';
import { requestUpdateUsernameApi } from '../requests/authenticate';

/**
 * Get customers with pagination
 * @param {*} payload
 */
function* requestCustomers(payload) {
  try {
    const response = yield requestCustomersApi(payload);

    yield put({ type: GET_CUSTOMERS_SUCCESS, data: { ...response } });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: REQUEST_ERROR });
      },
    });
  }
}

/**
 * Get detail data customer
 * @param {*} payload
 */
function* requestCustomerDetail(payload) {
  try {
    const { params } = payload;
    const data = yield requestCustomerDetailApi(params);
    yield put({ type: GET_DETAIL_SUCCESS, data });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
  }
}

/**
 * Update customer
 * @param {*} payload
 */
function* requestUpdateCustomer({ params, callback }) {
  try {
    const { data, message } = yield requestUpdateCustomerApi({
      guid: params.guid,
      params: params.values,
    });
    yield put({ type: UPDATE_CUSTOMER_SUCCESS, data });
    Message({ type: 'success', content: message });
    callback(data);
  } catch (error) {
    callback(error);
    yield onFailRequest({
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
  }
}

/**
 * Update customer avatar
 * @param {*} payload
 */
function* requestUpdateCustomerAvatar(payload) {
  try {
    const { file, oldFile, guid } = payload.params;
    if (oldFile) yield requestDeleteCustomerProfilePictureApi({ guid, userFileId: oldFile?.id });
    const res = yield requestCreateCustomerProfilePictureApi({ guid, file });
    yield put({ type: UPDATE_CUSTOMER_AVATAR_SUCCESS, data: { newFile: res?.data, oldFile } });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
  }
}

/**
 * Update customer username
 * @param {*} payload
 */
function* requestUpdateCustomerUsername(payload) {
  try {
    const { pending_username, guid } = payload.params;
    const res = yield requestUpdateUsernameApi({ guid, pending_username });
    yield put({ type: UPDATE_CUSTOMER_USERNAME_SUCCESS, data: res?.data });
    Message({ type: 'success', content: res.message });
    payload.callback(res);
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
    payload.callback(error);
  }
}

/**
 * Create customer
 * @param {*} payload
 */
function* requestCreateCustomer(payload) {
  try {
    const { data } = yield requestCreateCustomerApi(payload);
    Message({ type: 'success', content: 'You created new customer successfully!' });
    payload?.callback?.(true, data);
  } catch (error) {
    payload?.callback?.(false, error);
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: REQUEST_ERROR });
      },
    });
  }
}

export default [
  takeLatest(GET_CUSTOMERS, requestCustomers),
  takeLatest(UPDATE_CUSTOMER, requestUpdateCustomer),
  takeLatest(UPDATE_CUSTOMER_AVATAR, requestUpdateCustomerAvatar),
  takeLatest(UPDATE_CUSTOMER_USERNAME, requestUpdateCustomerUsername),
  takeLatest(CREATE_CUSTOMER, requestCreateCustomer),
  takeLatest(GET_DETAIL, requestCustomerDetail),
];
